import React from "react";
import { Navigate } from "react-router-dom";
import BrowserPhonePanel from "../../modules/telephony/browser-phone/BrowserPhonePanel";
import { useCallCenterT } from "../../hooks/useCallCenterT";
import { isWebCallingEnabled } from "../../utils/orgFeatures";

const CallCenterBrowserPhonePage = () => {
  const t = useCallCenterT();

  if (!isWebCallingEnabled()) {
    return <Navigate to="/call-center/dashboard" replace />;
  }

  return (
    <div className="min-h-screen bg-[#f9fafb] px-4 py-8">
      <div className="mx-auto flex max-w-3xl flex-col items-center">
        <div className="mb-6 max-w-lg text-center">
          <h1 className="text-[28px] font-bold tracking-tight text-[#111827]">{t("ccBrowserPhoneTitle")}</h1>
          <p className="mt-1 text-sm leading-6 text-slate-400">{t("ccBrowserPhonePageHint")}</p>
        </div>
        <div className="w-full max-w-sm">
          <BrowserPhonePanel />
        </div>
      </div>
    </div>
  );
};

export default CallCenterBrowserPhonePage;
